<script lang="ts">
	import type { HTMLAttributes, HTMLButtonAttributes } from "svelte/elements";
	import type { ButtonVariant } from "../../../../core/schema/ButtonVariant.js";
	import type { ButtonIcon } from "./ButtonIcon.js";
	import ButtonIconPart from "./ButtonIconPart.svelte";
	import { getButtonClass } from "./getButtonClass.js";

	const {
		variant,
		icon,
		onclick,
		children,
		type = onclick ? "button" : undefined,
		...rest
	}: {
		icon: ButtonIcon;
		variant: ButtonVariant;
	} & (HTMLButtonAttributes | (HTMLAttributes<HTMLSpanElement> & { type: "span" })) = $props();
</script>

<svelte:element
	this={type === "span" ? "span" : "button"}
	type={type === "span" ? undefined : type}
	{...rest}
	{onclick}
	class={[
		getButtonClass(variant),
		type === "span" && "w-fit",
		"group inline-flex items-center justify-center leading-none",
		icon !== "none" && "gap-2 md:gap-5",
		rest.class,
	]}
>
	{@render children?.()}
	<ButtonIconPart {icon} />
</svelte:element>
